import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";

const container = document.getElementById("root");
const root = createRoot(container);

// Rocket.new monitoring scripts removed — not needed for Render deployment
// and they cause CORS errors (application.rocket.new/preview/v1/track).

root.render(<App />);
